import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  // 百家号
  getFamilyList(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/scholar/nf/cnScholarList",
      data,
      false
    );
  },
  // 百家号
  bjDetailList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/nf/getUserDetailByUserId",
      data,
      false
    );
  },
  // 百科号
  getSectionList(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-user/searchUser/nf/periodicalList",
      data
    );
  },
  // async getSectionList(data) {
  //   return await axios({
  //     url: BASE_URL + "/zw-user/searchUser/nf/periodicalList",
  //     method: "post",
  //     data,
  //     headers: {
  //       rsa: "no",
  //     },
  //   });
  // },
  // 百科号
  bkDetailList(data) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/periodical/nf/detail", data);
  },
  // 近期最佳文章
  getReadRankingList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getReadRankingList",
      data,
      false
    );
  },
  // 百家百科文章
  getBlogList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getSyncInformationList",
      data,
      false
    );
  },
  // 百家课程列表
  getBjCourseList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleCurriculum/nf/listByUserId",
      data,
      false
    );
  },
  // 百科课程列表
  getBkCourseList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleCurriculum/nf/listByCompanyId",
      data,
      false
    );
  },
  // 百家文献
  getLiteratureList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getSyncThesisList",
      data,
      false
    );
  },
  getMobileSyncThesisList(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleUserForeign/nf/getMobileSyncThesisList",
      data,
      false
    );
  },
  getBkThesisPeriod(periodicalId) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-user/periodicalPhase/tree/${periodicalId}`,
      {},
      false
    );
  },
  getBkEditorialList(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-information/periodicalGuestLib/queryPageGroup",
      data,
      false
    );
  },
  // 百科论文
  getSyncBkThesisList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getSyncBkThesisList",
      data,
      false
    );
  },
  getOneList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/researchField/getOneList");
  },
  getTwoList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/researchField/getTwoList",
      data
    );
  },
  getSyncMonographList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getSyncMonographList",
      data,
      false
    );
  },
  getSyncReportList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/getSyncReportList",
      data,
      false
    );
  },
  getMeetingList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleMeeting/listByCompanyId",
      data,
      false
    );
  },
  nfdetail(data) {
    return zwitCore.HTTP.post(BASE_URL + "/zw-user/org/nf/detail", data);
  },
  articleVideo(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleVideo/nf/userlist",
      data,
      false
    );
  },
  getPerOneList() {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/perClassification/getPerOneList"
    );
  },
  getListByParentCode(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-public/perClassification/getListByParentCode",
      data
    );
  },
  // 百家详情发文/期刊/合作学者数量
  getBjArticleNumber(data) {
    return zwitCore.HTTP.get(
      BASE_URL +
        "/zw-information/articleUserForeign/nf/getExtraDetailCountByUserId",
      data,
      false
    );
  },
  // 百家详情发文/期刊/合作学者列表
  getBjArticleList(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/nf/baiJiaOnlineDetail",
      data,
      false
    );
  },
  // 机构详情页查询专著
  getUserDeatilZzList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMonograph/pageList",
      data,
      false
    );
  },
  // 机构详情页查询会议
  getUserDeatilHyList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleMeeting/pageList",
      data,
      false
    );
  },
  // 机构详情页查询课程
  getUserDeatilKcList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/articleCurriculum/pageList",
      data,
      false
    );
  },
  // 机构详情页查询图书商品
  getUserDeatilTsList(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-goods/goods/nf/getCompanyIdGetBooksList",
      data,
      false
    );
  },
  // 机构详情页查询万商数据商品
  getUserDeatilBgList(data) {
    return zwitCore.HTTP.post(
      BASE_URL + "/zw-goods/goods/nf/getCompanyIdGetBooksListNew",
      data,
      false
    );
  },
  getUserDetailTabs(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/articleUserForeign/nf/columnDisplay",
      data,
      false
    );
  },
  getPartnerDetailTabs(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-user/permissions/nf/getPartnerRold",
      data,
      false
    );
  },
  getLatestPeriodical(id) {
    return zwitCore.HTTP.get(
      BASE_URL + `/zw-user/periodicalPhase/last/${id}`,
      {},
      false
    );
  },
};
